import { useQuery } from '@apollo/client';
import { GET_UPERCUT_USER_PERMISSIONS } from '@gql/upercut-permissions';

export const useUpercutPermissions = () => {
    const { data, loading, error, refetch } = useQuery(GET_UPERCUT_USER_PERMISSIONS, {
        fetchPolicy: 'cache-and-network',
    });

    const permissions: string[] = data?.upercutUserPermissions ?? [];

    const hasPermission = (permission: string) => permissions.includes(permission) || permissions.includes('*:*');
    const hasAnyPermission = (required: string[]) => required.some(permission => hasPermission(permission));
    const hasAllPermissions = (required: string[]) => required.every(permission => hasPermission(permission));
   

    return {
        permissions,
        loading,
        error,
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        refresh: () => refetch(),
    };
};
